<template>
  <div>
    <Modal v-model="isShow" @on-ok="ok" :loading="loading" :mask-closable="false" :class-name="z100000">
      <h3 slot="header" class="modal-header">图片上传</h3>
      <div style="display: flex;flex-wrap: wrap">
        <template v-for="item in data " v-if="data">
          <div class="fileItem">
            <div style="margin-bottom: 10px;">
              <img class="file-img" :src="item.attachmentImgUrl" alt="">
              <a href="javascript:;" style="vertical-align: bottom" @click="deleteItem(item)">删除</a>
            </div>
            <Input class="input-width" v-model="item.attachmentClickUrl" placeholder="跳转地址"/>
          </div>
        </template>
        <div class="fileItem">
          <Upload class="upload"
                  :action="baseUrl+'/file/uploadFile'"
                  :on-success="handleSuccess"
                  :headers="{'Access-Token':token}"
                  :show-upload-list="false"
                  :on-error="handleError"

          >
            <Icon type="ios-plus-empty" size="80" style="vertical-align: middle"></Icon>
          </Upload>

        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
  import {getBaseUrl} from "../../../../utils/public";
  import {getToken} from "../../../../utils/auth";
  import {
    labelgetConfigImg,
    labeladdConfigImg,
    labeleditConfigImg,
    labelremoveConfigImg
  } from "../../../../api/projectConfig";

  export default {
    name: "ImgUpload",
    props: {
      n: {
        type: Number,
        default: 0
      },
      fid: {
        type: String,
        default: ''
      }
    },
    watch: {
      n() {
        this.data=[]
        this.labelgetConfigImg()
        this.isShow = true
      },
      // fid(){
      //   this.labelgetConfigImg()
      // }
    },
    data() {
      return {
        isShow: false,
        data: [],
        loading: true,
        token: '',
        baseUrl: '',
        z100000: 'z100000',
      }
    },
    methods: {
      labelgetConfigImg() {
        if (!this.fid) {
          return
        }
        let params = {
          fid: this.fid
        }
        labelgetConfigImg(params).then(res => {
          this.data = res.data
        })
      },
      handleError() {

      },
      handleSuccess(res) {
        let params = {
          fid: res.data.fid,
          attachmentImgUrl: res.data.url,
          moduleFid: this.fid
        }
        labeladdConfigImg(params).then(res1 => {
          this.data.push(res1.data)
        })
      },
      deleteItem(item) {

        let params = {
          fid: item.fid
        }
        labelremoveConfigImg(params).then(res => {
          this.labelgetConfigImg()
        })
        // this.$Modal.confirm({
        //   content: '<p>确认删除？</p>',
        //   onOk: () => {
        //     let params={
        //       fid:item.fid
        //     }
        //     labelremoveConfigImg(params).then(res=>{
        //       this.labelgetConfigImg()
        //     })
        //
        //   }
        // })


      },
      ok() {
        this.data.forEach((ele, index) => {
          ele['attachmentOrder'] = index
        })
        labeleditConfigImg(this.data).then(res => {
          this.isShow = false
          this.$Message.success('图片配置成功')
        })
      },
    },
    created() {
      this.baseUrl = getBaseUrl()
      this.token = getToken()
    }

  }
</script>

<style scoped>
  .upload {
    display: inline-block;
    width: 150px;
    height: 85px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;
    line-height: 80px;
  }

  .fileItem {
    margin-right: 20px;
  }

  .content-right {
    /*border: 1px solid black;*/
    overflow: hidden;
    display: flex;
    padding-left: 20px;
    box-sizing: border-box;

  }

  .file-img {
    width: 150px;
    height: 85px;
    overflow: hidden;
    display: inline-block;
    /*margin-bottom: 20px;*/
  }

  .input-width {
    width: 150px;
    margin-bottom: 10px;
  }


</style>
